import { useState } from 'react';

import { SearchOutlined } from '@ant-design/icons';

import { Input, Table } from 'antd';

import { globalSearch } from '@/utils/search/Search';

import { useDeviceIds } from './query/useDeviceIds';
import { DeleteModal } from './deleteModal';
import '@/assets/style/modern-group-list.css';

/**
 *
 * @returns
 */

const columns = [
  {
    title: 'S.N',
    align: 'center',
    render: (_, __, index) => index + 1,
    width: 50,
  },
  {
    title: 'Full Name',
    dataIndex: 'fullName',
    key: 'fullName',
    align: 'left',
    width: '20%',
  },
  {
    title: 'User',
    dataIndex: 'username',
    key: 'username',
    align: 'left',
    width: '20%',
  },
  {
    title: 'OS Name',
    dataIndex: 'osName',
    key: 'osName',
    align: 'left',
  },
  {
    title: 'Browser Name',
    dataIndex: 'browserName',
    key: 'browserName',
    align: 'left',
  },
  {
    title: 'Action',
    render: (record) => (
      <>
        <div className="ant-action tw-flex tw-gap-4 tw-justify-center">
          <DeleteModal id={record.referenceId} />
        </div>
      </>
    ),
    align: 'center',
    width: 80,
  },
];

export function DeviceIdList() {
  const { data, isLoading } = useDeviceIds();
  const [searchQuery, setSearchQuery] = useState('');
  return (
    <>
      <div className="modern-group-page">
        <div className="modern-group-header-row">
          <div className="modern-group-header">
            <h1 className="modern-group-title">Device Identification</h1>
            <p className="modern-group-subtitle">
              Manage and monitor registered devices
            </p>
          </div>
          <div className="modern-group-actions">
            <Input
              className="header-search"
              name="query"
              placeholder="Search User..."
              prefix={<SearchOutlined />}
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
              style={{ width: '300px' }}
            />
          </div>
        </div>

        <div className="table-responsive modern-table-wrapper">
          <Table
            size="large"
            bordered
            loading={isLoading}
            columns={columns?.map((col) => ({
              ...col,
              onCell: () => ({
                style: { padding: '6px 12px' },
              }),
            }))}
            className="ant-border-space"
            style={{ textAlign: 'center' }}
            scroll={{ x: true, y: 'calc(100vh - 220px)' }}
            pagination={false}
            dataSource={
              data?.data ? globalSearch(data?.data, searchQuery) : []
            }
          />
        </div>
      </div>
    </>
  );
}
